import { useEffect, useState } from 'react'

import {
  getInitPartnerTerritory,
  IPartnerTerritory,
} from 'onboarding/classes/models/partnerTerritoryModels'
import { fail } from 'onboarding/classes/services/notification'
import { partnerTerritoryService } from 'onboarding/services/partnerTerritoryService'

export const usePartnerTerritory = () => {
  const [territory, setTerritory] = useState<IPartnerTerritory>(getInitPartnerTerritory)

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await partnerTerritoryService.fetchPartnerTerritory()
        setTerritory(data)
      } catch (e) {
        setTerritory(getInitPartnerTerritory())
        fail('Failed to get partner territory')
      }
    }
    fetch()
  }, [])

  return territory
}
